import {apiRequest} from "../../service/service";

class Api {
    doSearch = (params = {}) => {
        const url = `search`;
        const config = {
            method:'get',
            url:url,
            params
        };
        return apiRequest(config);
    };
}

export default Api;
